import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { setTable } from '../redux/actions/table';
import { Redirect } from 'react-router-dom';
import { getData } from '../redux/actions/restaurant';

function Table({ setTable, error, table, getData, details }) {
    const [inputTable, setInputTable] = useState("");

    useEffect(() => {
        getData();
    }, [])

    const handleSubmit = () => {
        setTable(inputTable);
    }

    if (table && !error) {
        return <Redirect to="/" />
    }


    return (
        <div className="container" style={{ marginTop: "100px" }}>
            {error && <div className="alert alert-danger">
                {error}
            </div>}
            <div className="table-booking-login">
                <div className="login-container">
                    <h3 className="text-white">ENTER TABLE NUMBER</h3>
                    <div className="input-row">
                        <div className="col-1">
                            <input type="text" className="form-input text-center" placeholder="Enter Table no." value={inputTable} onChange={(e) => setInputTable(e.target.value)} />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="col-1 text-center">
                            <input className="btn w-50" type="submit" value="Submit" onClick={handleSubmit} />
                        </div>
                    </div>
                    {details && <p className="text-center font-small  mt-25 info-text">{details.table_text}</p>}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    error: state.table.error,
    table: state.table.table,
    details: state.restaurant.details
})

export default connect(mapStateToProps, { setTable, getData })(Table)
